module.exports = __webpack_public_path__ + "assets/weChatIcon.907eff38.svg";